export const CATEGORIES = 'categories';
export const PROMOTION_CATEGORIES = 'promotion-categories';
